import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchReturnDetail = createAsyncThunk("fetchReturnDetail", async (id, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.get(`return/${id}`);
		return response.data.data;
	} catch (error) {
		return rejectWithValue(error.response?.data?.message || "Something went wrong while fetching detail");
	}
});

const ReturnApprovalsDetailSlice = createSlice({
	name: "ReturnApprovalsDetailSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchReturnDetail.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchReturnDetail.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});

		builder.addCase(fetchReturnDetail.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload || action.error.message || "Unknown error occurred";
		});
	},
});

export default ReturnApprovalsDetailSlice.reducer;
